import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'world',
		// SERVER: 'http://127.0.0.1:8000',
		SERVER: 'https://tree.rest',
	}
});

export default app;